<template>
    <section class="no-content-box" :style="heightCss">
		<div class="reload-btn" @click="reset" v-if="!load && reloadBtn">
			<i class="far fa-sync"></i>
		</div>
		<div>
			<div class="load-info" v-if="load">
				<ui-load-indicator bgColor="#FFF" color="#69D296" :h="70" :stroke="8"></ui-load-indicator>
			</div>
			<div class="icon" v-if="icon && !load">
				<i :class="icon"></i>
			</div>
			<div v-if="!load">
				<div class="text" v-html="text"></div>
				<div class="control" v-if="btnText">
					<ui-button type="button"
						design="sm success rounded mw-150" 
						@click="action">
						{{btnText}}
					</ui-button>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import uiLoadIndicator from '@/components/ui/load-indicator'
	import helpers from '@/mixins/helpers'

    export default {
		name: 'ui-no-content-box',
		components: { uiButton, uiLoadIndicator },
		mixins: [ helpers ],
		props:{
			icon: {
				type: String,
				required: false,
			},
			load: {
				type: Boolean,
				required: false,
			},
			text: {
				type: String,
				required: true,
			},
			btnText: {
				type: String,
			},
			maxHeight: {
				type: Number,
				required: false,
			},
			goTo: {
				type: String,
				required: false,
				default: null
			},
			goToLegacy: {
				type: String,
				required: false,
			},			
			reloadBtn: {
				type: Boolean,
				default: true,
				required: false
			},
			modal: {
				type: String,
				required: false,
				default: null
			}
		},
		data() {
            return {
				heightCss: {
					height: this.maxHeight + 'px'
				}, 
				resetButton: false,
				reload: false,
				buttonLoading: false,
            }
		},
		methods:{
			reset(){
				this.reload = true
				this.$parent.$emit("clear-filter");
			},
			action() {
				if (this.goTo) {
					this.$router.push({ path: this.goTo })

				} else if (this.goToLegacy) {
					this.oldPanelLinkButton(this.goToLegacy)

				} else {
					this.$emit("click")
				}
			}
		},
	};
</script>

<style lang="stylus" scoped>
	@import './styles.styl';

</style>
